export default __webpack_public_path__ + "static/media/expert4.4ae9eb58.png";